const AdminRoles = {
  ROLE_PORTFOLIO_ADMIN: 'ROLE_PORTFOLIO_ADMIN',
  ROLE_ADMIN: 'ROLE_ADMIN',
  _Values: () =>
    Object.keys(AdminRoles)
      .filter(key => typeof AdminRoles[key] !== 'function')
      .map(key => AdminRoles[key]),
};

const ManagerRoles = {
  ROLE_PROPERTY_MANAGER: 'ROLE_PROPERTY_MANAGER',
  ROLE_PORTFOLIO_MANAGER: 'ROLE_PORTFOLIO_MANAGER',
  _Values: () =>
    Object.keys(ManagerRoles)
      .filter(key => typeof ManagerRoles[key] !== 'function')
      .map(key => ManagerRoles[key]),
};

const SupportRoles = {
  ROLE_SUPPORT_USER: 'ROLE_SUPPORT_USER',
  ROLE_LOAN_SUPPORT: 'ROLE_LOAN_SUPPORT',
  _Values: () =>
    Object.keys(SupportRoles)
      .filter(key => typeof SupportRoles[key] !== 'function')
      .map(key => SupportRoles[key]),
};

const AccountRoles = {
  ROLE_CUSTOMER: 'ROLE_CUSTOMER',
  ROLE_PROPERTY_MANAGER: ManagerRoles.ROLE_PROPERTY_MANAGER,
  ROLE_PORTFOLIO_MANAGER: ManagerRoles.ROLE_PORTFOLIO_MANAGER,
  ROLE_PORTFOLIO_ADMIN: AdminRoles.ROLE_PORTFOLIO_ADMIN,
  ROLE_ADMIN: AdminRoles.ROLE_ADMIN,
  ROLE_SUPPORT_USER: SupportRoles.ROLE_SUPPORT_USER,
  ROLE_LOAN_SUPPORT: SupportRoles.ROLE_LOAN_SUPPORT,
  _Values: () =>
    Object.keys(AccountRoles)
      .filter(key => typeof AccountRoles[key] !== 'function')
      .map(key => AccountRoles[key]),
};

module.exports = {
  AdminRoles,
  ManagerRoles,
  SupportRoles,
  AccountRoles,
};
